import { useMemo } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

import { blue500, gray300, gray900 } from "../../uiKit/assets/colors/colors";
import { Magnificer } from "../../uiKit/assets/svg/icons";
import CustomButton from "../../uiKit/Button/CustomButton";
import CustomInput from "../../uiKit/Input/CustomInput";
import Title from "../../uiKit/Title/Title";

const CommunityTabs = [
  { id: 0, title: "All Communities", url: "/communities/all" },
  { id: 1, title: "My Communities", url: "/communities/my" },
];

const CommunitiesHeader = () => {
  const history = useHistory();
  const { pathname, search } = useLocation();
  const query = useMemo(() => new URLSearchParams(search), [search]);
  const screenWidth = useSelector((state) => state.common.screenWidth);
  const isMobile = screenWidth <= 767;

  const searchCommunityHandler = (e) => {
    const value = e.target.value;
    query.set("searchString", value);

    if (!value) {
      query.delete("pageSize");
      query.delete("searchString");
    }

    history.replace({
      pathname,
      search: query.toString(),
    });
  };

  const createNewCommunityHandler = () => {
    history.push("/new-community");
  };

  return (
    <div className="communityHeader">
      <div className="communityTitle">
        <Title text={"Communities"} fontSize={isMobile ? 16 : 32} lineHeight={isMobile ? 20 : 40} />
        <CustomButton title={"Create new Community"} onClick={createNewCommunityHandler} />
      </div>
      <div className="tabs">
        <div style={{ display: "flex" }}>
          {CommunityTabs.map((x) => (
            <Title
              key={x.id}
              text={x.title}
              onClick={() => history.push(x.url)}
              color={pathname.includes(x.url) ? blue500 : gray900}
              style={{
                width: "184px",
                minHeight: "40px",
                textAlign: "center",
                padding: "8px 24px",
                borderBottom: "2px solid",
                borderColor: pathname.includes(x.url) ? blue500 : gray300,
                cursor: "pointer",
              }}
            />
          ))}
        </div>
        <div>
          <CustomInput
            placeholder="Search community"
            StartAdornment={Magnificer}
            onChange={searchCommunityHandler}
            value={query.get("searchString")}
          />
        </div>
      </div>
    </div>
  );
};

export default CommunitiesHeader;
